import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Klassenbuch } from '../_models/klassenbuch';

@Component({
  selector: 'mergecoursemodal',
  templateUrl: './mergecoursemodal.component.html',
  styles: ['.modal {background: rgba(0, 0, 0, 0.6);}']
})
export class MergecoursemodalComponent implements OnInit {

  constructor() {
    this.entry1.trainer = "";
    this.entry1.thema = "";
    this.entry1.inhalte = "";
    this.entry2.trainer = "";
    this.entry2.thema = "";
    this.entry2.inhalte = "";
  }

  ngOnInit() {
  }

  public visible = false;
  public visibleAnimate = false;

  entry1: Klassenbuch = new Klassenbuch(new Date());
  entry2: Klassenbuch = new Klassenbuch(new Date());

  @Output()
    choosenCourseBook:  EventEmitter<Klassenbuch[]> = new EventEmitter<Klassenbuch[]>();

  public show(entry1: Klassenbuch,entry2: Klassenbuch): void {
    this.entry1 = entry1;
    this.entry2 = entry2;
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
    this.choosenCourseBook.emit(null);
  }

  public choose1(): void {
    console.log("choose1 click");
    let kb: Klassenbuch[] = [];
    kb.push(this.entry1);
    kb.push(this.entry2);
    this.choosenCourseBook.emit(kb);
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public choose2(): void {
    console.log("choose2 click");
    let kb: Klassenbuch[] = [];
    kb.push(this.entry2);
    kb.push(this.entry1);
    this.choosenCourseBook.emit(kb);
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/_components/mergecoursemodal.component.ts